export const draggableMixin={
    data() {
        return {
            dragEntries: [] // [{ el, header, onPointerDown, onPointerMove, onPointerUp, onResize, isDragging, offsetX, offsetY }]
        };
    },

    mounted() {
        // aspetta il DOM del componente
        this.$nextTick(() => {
            const draggableElements=document.querySelectorAll('.draggable-item, .draggable-item-little');
            const parentElement=document.querySelector('.shifted-content'); // contenitore di riferimento
            const getBounds=() => (parentElement? parentElement.getBoundingClientRect():document.documentElement.getBoundingClientRect());
            let self=this;
            draggableElements.forEach(el => {
                const header=el.querySelector('.dialog-title');
                if (!header) return;

                // Stato per questo elemento
                const entry={
                    el, header,
                    isDragging: false,
                    offsetX: 0,
                    offsetY: 0
                };

                // Centra l'elemento nel parent/viewport
                const centerElement = () => {
                    const pr = getBounds();
                    const elW = el.offsetWidth;
                    const elH = el.offsetHeight;
                    /*el.style.position = el.style.position || 'fixed';
                    el.style.left = "50%";//`${pr.left + (pr.width - elW) / 2}px`;
                    el.style.top = "50%";//`${pr.top + (pr.height - elH) / 2}px`;
                    el.style.transform = 'none';*/
                };


                // Resize: se non stai trascinando, rientra al centro
                entry.onResize=() => {
                    if (!entry.isDragging) centerElement();
                };
                window.addEventListener('resize', entry.onResize);
                // Solo se NON clicchi su elementi interattivi nell'header (es. .closer, button, a, input…)
                const isInteractive=(target) =>
                    !!target.closest?.('.closer, .button, button, a, input, textarea, select, [data-no-drag]');

                entry.onPointerDown=(e) => {
                    if (isInteractive(e.target)) return; // lascia passare il click al bottone di chiusura

                    entry.isDragging=true;
                    el.classList.add('draggable-on');

                    const rect=el.getBoundingClientRect();
                    entry.offsetX=e.clientX-rect.left;
                    entry.offsetY=e.clientY-rect.top;

                    // togli il centering durante il drag
                    el.style.transform='none';

                    // cattura il puntatore per ricevere gli eventi anche fuori dall'header
                    header.setPointerCapture?.(e.pointerId);

                    // alza lo z-index se serve
                    // el.style.zIndex = '1041';
                };

                // pointermove globale
                entry.onPointerMove=(e) => {
                    if (!entry.isDragging) return;
                    const pr=getBounds();
                    const elW=el.offsetWidth;
                    const elH=el.offsetHeight;

                    let newLeft=e.clientX-entry.offsetX;
                    let newTop=e.clientY-entry.offsetY;

                    // vincola al contenitore
                    newLeft=Math.max(pr.left, Math.min(newLeft, pr.right-elW));
                    newTop=Math.max(pr.top, Math.min(newTop, pr.bottom-elH));

                    el.style.left=`${newLeft}px`;
                    el.style.top=`${newTop}px`;
                };

                // pointerup globale
                entry.onPointerUp=(e) => {
                    if (!entry.isDragging) return;
                    entry.isDragging=false;
                    el.classList.remove('draggable-on');
                    header.releasePointerCapture?.(e.pointerId);
                    // el.style.zIndex = '1001';
                };

                // attach
                header.addEventListener('pointerdown', entry.onPointerDown, { passive: true });
                window.addEventListener('pointermove', entry.onPointerMove, { passive: true });
                window.addEventListener('pointerup', entry.onPointerUp, { passive: true });

                // posiziona inizialmente
                centerElement();

                // salva per cleanup
                self.dragEntries.push(entry);
            });
        });
    },

    // Vue 2
    beforeDestroy() {
        this._cleanupDrag();
    },
    // Vue 3
    beforeUnmount() {
        this._cleanupDrag();
    },

    methods: {
        _cleanupDrag() {
            if (!this.dragEntries) return;
            this.dragEntries.forEach(entry => {
                if (!entry) return;
                const { header, onPointerDown, onPointerMove, onPointerUp, onResize }=entry;
                window.removeEventListener('resize', onResize);
                header&&header.removeEventListener('pointerdown', onPointerDown);
                window.removeEventListener('pointermove', onPointerMove);
                window.removeEventListener('pointerup', onPointerUp);
            });
            this.dragEntries=[];
        }
    }
};